import angular from 'angular';

import AutofocusDirective, { selector } from './autofocus.directive';

export default angular
    .module('application.directive.autofocus', [])
    .directive(selector, AutofocusDirective);



// WEBPACK FOOTER //
// ./src/application/directive/autofocus/index.js